import { render, staticRenderFns } from "./PlantPagination.vue?vue&type=template&id=49744749"
import script from "./PlantPagination.vue?vue&type=script&lang=js"
export * from "./PlantPagination.vue?vue&type=script&lang=js"
import style0 from "./PlantPagination.vue?vue&type=style&index=0&id=49744749&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports